import clsx from 'clsx';
import { Link } from 'react-router-dom';
import Page from '../layout/components/Page';
import { useFetchInvestments } from '../hooks/investment/useFetchInvestments';
import { InvestmentRow } from '../components/Investment/InvestmentRow';
import LoadingIndicator from '../components/Common/LoadingIndicator';
import Modal from '../components/Common/Modal';
import LoanTypeFilter from '../components/Common/LoanTypeFilter';
import { CountryFilter } from '../components/Common/CountryFilter';
import { Loan, LoanStatus } from '../interfaces';
import Paginate from '../components/Common/Paginate';
import { useErrorHandler } from 'react-error-boundary';

const InvestmentsPage = () => {
  const { error, page, menu, loading, showForm, pagination, pageQuery, toggleForm, makeActive, investmentTypes, handleFilterInvestments, countrySelection, updateCountryValues, closedInvestments, activeInvestments, updateInvestmentTypeValues, underwritingInvestments } = useFetchInvestments();
  useErrorHandler(error)

  const renderInvestments = (investments: Loan[]) => {
    return (
      <div className='w-100 pt-10 pb-10'>
        <div className='table-responsive'>
          <table className='table table-bordered align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bolder text-muted bg-light'>
                <th className='ps-4 min-w-325px rounded-start'>Loan Title</th>
                <th className='min-w-100px'>Amount</th>
                <th className='min-w-100px'>Repayment</th>
                <th className='min-w-70px'>Interest</th>
                <th className='text-end rounded-end'></th>
              </tr>
            </thead>

            <tbody>
              {investments.map((investment) => (
                <InvestmentRow key={investment.id} investment={investment} />
              ))}
            </tbody>
          </table>
        </div>
        {pagination && <Paginate pagination={pagination} pageLink={`/investments/${menu}`} pageQuery={pageQuery} />}
      </div>
    );
  };

  const renderChildren = (
    <>
      <button className='btn btn-sm btn-flex btn-light-primary btn-active-primary fw-bolder me-2' onClick={toggleForm}>
        <i className='bi bi-filter'></i>
        Filter Investments
      </button>
    </>
  );

  return (
    <>
      <Page title='Investments' icon='bi-bar-chart-steps' toolbarChildren={renderChildren}>
        <div className='card'>
          <div className='card-body'>
            <div className='d-flex overflow-auto h-55px'>
              <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-6 fw-bolder flex-nowrap'>
                <li className='nav-item'>
                  <Link className={clsx('nav-link text-active-primary me-6', makeActive('underwriting'))} to={`/investments/${LoanStatus.UNDERWRITING}${pageQuery()}`}>
                    Underwriting
                  </Link>
                </li>
                <li className='nav-item'>
                  <Link className={clsx('nav-link text-active-primary me-6', makeActive('active'))} to={`/investments/${LoanStatus.ONGOING}${pageQuery()}`}>
                    Active
                  </Link>
                </li>
                <li className='nav-item'>
                  <Link className={clsx('nav-link text-active-primary me-6', makeActive('closed'))} to={`/investments/${LoanStatus.CLOSED}${pageQuery()}`}>
                    Closed
                  </Link>
                </li>
              </ul>
            </div>

            {loading && ((menu === LoanStatus.UNDERWRITING && !underwritingInvestments) || (menu === LoanStatus.ONGOING && !activeInvestments) || (menu === LoanStatus.CLOSED && !closedInvestments)) && (
              <div className='mt-3'>
                <LoadingIndicator message='' />
              </div>
            )}

            {page === 1 && ((menu === LoanStatus.UNDERWRITING && underwritingInvestments && !underwritingInvestments.length) || (menu === LoanStatus.ONGOING && activeInvestments && !activeInvestments.length) || (menu === LoanStatus.CLOSED && closedInvestments && !closedInvestments.length)) && (
              <div className='d-flex justify-content-center align-item-center'>
                <div className='text-center pt-20 pb-20'>
                  <i className='bi bi-folder' style={{ fontSize: '3.5em' }}></i>
                  <p className='text-muted ms-20p me-20p pt-3 pb-3'>You currently have no {menu} investments.</p>
                  {/* <Link type='submit' className='btn btn-primary' to='/loans/apply'>
                  Make Loan Offer
                </Link> */}
                </div>
              </div>
            )}

            {menu === LoanStatus.UNDERWRITING && underwritingInvestments && underwritingInvestments.length ? renderInvestments(underwritingInvestments) : null}

            {menu === LoanStatus.ONGOING && activeInvestments && activeInvestments.length ? renderInvestments(activeInvestments) : null}

            {menu === LoanStatus.CLOSED && closedInvestments && closedInvestments.length ? renderInvestments(closedInvestments) : null}
          </div>
        </div>
      </Page>

      <Modal show={showForm} toggle={toggleForm} title='Filter Loan'>
        <label className='fs-8 text-muted'>Loan Type</label>
        <LoanTypeFilter defaultValues={investmentTypes} updateSelectedValue={updateInvestmentTypeValues} />
        <label className='fs-8 text-muted mt-3'>Country</label>
        <CountryFilter defaultValues={countrySelection} updateSelectedValue={updateCountryValues} />
        <button className='btn btn-sm btn-light-primary fw-bolder text-center mt-10 align-center' data-kt-menu-dismiss='true' onClick={handleFilterInvestments}>
          Apply
        </button>
      </Modal>
    </>
  );
};

export default InvestmentsPage;
